import { CustomLink } from '../../../../components/CustomLink';
import { s3CloudFrontUrlEndpoint } from '../../../../utils/common';

const chevronRightGray800 = `${s3CloudFrontUrlEndpoint}/svg/chevron-right-gray-800-24x24_vGM4GB8Io.svg`;

interface MoreRecipeLinkProps {
  title: string;
  link: string;
  count?: number;
}
const MoreRecipeLink = ({ title, link, count }: MoreRecipeLinkProps) => {
  return (
    <CustomLink
      href={link}
      className="inline-flex items-center gap-4px text-22px font-bold text-gray-800"
    >
      <span>{title}</span>
      {count && <span className="text-brand-1">{count}</span>}
      <img src={chevronRightGray800} alt="" />
    </CustomLink>
  );
};

export default MoreRecipeLink;
